import { useTranslation } from "react-i18next";

const T = { cyan: "#1CBCD3", sub: "#94A3B8" };

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "en" : "fr";

  const pill = (lang, label) => ({
    padding: "4px 10px",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: 700,
    cursor: "pointer",
    color: current === lang ? "#fff" : T.sub,
    background: current === lang ? T.cyan : "transparent",
    transition: "all 0.15s",
  });

  return (
    <div style={{ display: "flex", gap: "4px", background: "#F1F5F9",
      borderRadius: "10px", padding: "3px" }}>
      <span style={pill("fr", "FR")} onClick={() => i18n.changeLanguage("fr")}>FR</span>
      <span style={pill("en", "EN")} onClick={() => i18n.changeLanguage("en")}>EN</span>
    </div>
  );
}
